var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "validatePasswordForm",
      staticClass: "dg-validate-password-form",
      attrs: {
        id: "validatePasswordForm",
        inline: _vm.inline,
        model: _vm.sonFormData,
        rules: _vm.rules,
        "label-width": _vm.labelWidth,
        "label-position": _vm.labelPosition,
      },
    },
    [
      _vm.sonFormData.hasOwnProperty("oldPassword")
        ? _c(
            "el-form-item",
            { attrs: { label: "旧密码：", prop: "oldPassword" } },
            [
              _c("el-input", {
                attrs: {
                  size: _vm.inputSize,
                  type: "password",
                  maxlength: "32",
                  "show-password": "",
                },
                nativeOn: {
                  "!paste": function ($event) {
                    $event.preventDefault()
                    return _vm.handleFalse.apply(null, arguments)
                  },
                  "!copy": function ($event) {
                    $event.preventDefault()
                    return _vm.handleFalse.apply(null, arguments)
                  },
                  "!cut": function ($event) {
                    $event.preventDefault()
                    return _vm.handleFalse.apply(null, arguments)
                  },
                },
                model: {
                  value: _vm.sonFormData["oldPassword"],
                  callback: function ($$v) {
                    _vm.$set(_vm.sonFormData, "oldPassword", $$v)
                  },
                  expression: "sonFormData['oldPassword']",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.captchaImage
        ? _c(
            "el-form-item",
            { attrs: { label: "验证码：", prop: "captcha" } },
            [
              _c(
                "div",
                { staticClass: "captcha-row" },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "验证码",
                      "suffix-icon":
                        "glyphicon glyphicon-warning-sign form-control-feedback",
                      size: _vm.inputSize,
                    },
                    model: {
                      value: _vm.sonFormData.captcha,
                      callback: function ($$v) {
                        _vm.$set(_vm.sonFormData, "captcha", $$v)
                      },
                      expression: "sonFormData.captcha",
                    },
                  }),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "captcha-img",
                    style: {
                      height:
                        { mini: "28px", small: "32px", large: "40px" }[
                          _vm.inputSize
                        ] || "32px",
                    },
                    attrs: {
                      alt: "如果看不清楚，请单击图片刷新！",
                      src: _vm.captchaImageSrc,
                    },
                    on: { click: _vm.refreshCode },
                  }),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "新密码：", prop: "password" } },
        [
          _c(
            "el-popover",
            {
              ref: "password-popover",
              attrs: { placement: "right", width: "400", trigger: "focus" },
            },
            [
              _vm._l(_vm.validatorTips, function (tip, index) {
                return [
                  _c("div", { key: index, staticClass: "validator-tip" }, [
                    tip.type === "success"
                      ? _c("i", {
                          staticClass:
                            "el-icon-success el-alert--success is-light",
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    tip.type === "error"
                      ? _c("i", {
                          staticClass: "el-icon-error el-alert--error is-light",
                        })
                      : _c("i"),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(tip.text))]),
                  ]),
                ]
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "safeness" },
                [
                  _vm._v("\n        安全程度：\n        "),
                  _vm._l(_vm.safenessArray, function (span, index) {
                    return _c("span", {
                      key: index,
                      class: "el-button--" + span.type,
                    })
                  }),
                  _vm._v("\n        " + _vm._s(_vm.safenessText) + "\n      "),
                ],
                2
              ),
            ],
            2
          ),
          _vm._v(" "),
          _c("el-input", {
            directives: [
              {
                name: "popover",
                rawName: "v-popover:password-popover",
                arg: "password-popover",
              },
            ],
            attrs: {
              size: _vm.inputSize,
              type: "password",
              maxlength: "32",
              "show-password": "",
            },
            nativeOn: {
              "!paste": function ($event) {
                $event.preventDefault()
                return _vm.handleFalse.apply(null, arguments)
              },
              "!copy": function ($event) {
                $event.preventDefault()
                return _vm.handleFalse.apply(null, arguments)
              },
              "!cut": function ($event) {
                $event.preventDefault()
                return _vm.handleFalse.apply(null, arguments)
              },
            },
            model: {
              value: _vm.sonFormData["password"],
              callback: function ($$v) {
                _vm.$set(_vm.sonFormData, "password", $$v)
              },
              expression: "sonFormData['password']",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "确认密码：", prop: "passwordSure" } },
        [
          _c("el-input", {
            attrs: {
              size: _vm.inputSize,
              type: "password",
              maxlength: "32",
              "show-password": "",
            },
            nativeOn: {
              "!paste": function ($event) {
                $event.preventDefault()
                return _vm.handleFalse.apply(null, arguments)
              },
              "!copy": function ($event) {
                $event.preventDefault()
                return _vm.handleFalse.apply(null, arguments)
              },
              "!cut": function ($event) {
                $event.preventDefault()
                return _vm.handleFalse.apply(null, arguments)
              },
            },
            model: {
              value: _vm.sonFormData["passwordSure"],
              callback: function ($$v) {
                _vm.$set(_vm.sonFormData, "passwordSure", $$v)
              },
              expression: "sonFormData['passwordSure']",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }